<template>
  <div class="m-equity">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" ></Search>
    <div class="fun-btn-box">
      <auth-button auth="member:config:benefit:create">
        <el-button type="primary" class="fun-btn mr10" @click="onAdd" >+ 创建权益</el-button>
      </auth-button>
    </div>
    <Table
      :loading="loading"
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #name="{ row }">{{ row.name }}</template>
      <template #logo="{ row }">
        <img class="equity-url" :src="row.logo" alt="" srcset="">
      </template>
      <template #remark="{ row }">{{ row.remark }}</template>
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #operation="{ scope }">
        <auth-button auth="member:config:benefit:update">
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
        </auth-button>
        <auth-button auth="member:config:benefit:delete">
          <el-button type="text" class="error ml10" @click="deleteRow(scope.row)">删除</el-button>
        </auth-button>
      </template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import Search from "@/components/Search/index"
import Table from "@/components/Table/index"
import Dialog from "@/components/Dialog/index"
import { api_getPageBenefit, api_deleteMemberBenefit } from '@/api/member'
import tableList from '@/mixins/tableList'
export default {
  name: "mEquity",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
    Dialog
  },
  data() {
    return {
      renderData: [
        {
          label: "权益名称",
          placeholder: "请输入权益名称",
          type: "input",
          key: "name",
        }
      ],
      form: {
        name: "",
      },
      tableThData: [
        { prop: "name", label: "权益名称", minWidth: "120", },
        { prop: "logo", label: "权益图片", minWidth: "150", },
        { prop: "remark", label: "会员权益", minWidth: "230", },
        { prop: "created", label: "创建时间", minWidth: "260", },
        { prop: "operation", label: "操作", minWidth: "160", },
      ],
      tableTrData: [],
    };
  },
  created () {
  },
  methods: {
    onAdd () {
      this.$router.push({
        path: '/member/equity/create'
      })
    },
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      const data = await api_getPageBenefit({name: this.form.name, limit: this.limit, offset: this.offset})
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },
    // 编辑
    edit (row) {
      this.$router.push({
        path: '/member/equity/create?id=' + row.id
      })
    },
    // 删除
    deleteRow (row) {
      this.$baseConfirm(
        '是否确认删除？',
        {
          title: '提示',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning',
        },
        async () => {
          await api_deleteMemberBenefit({id: row.id})
          this.$baseMessage('删除成功', 'success')
          this.getList()
        }
      )
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.m-equity {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  .fun-btn-box {
    margin-top: 20px;
  }
  .equity-url{
    width: 120px;
    height: 56px;
    object-fit: fill;
    object-fit: contain;
    object-fit: cover;
    object-fit: none;
    object-fit: scale-down;
  }
}
</style>
